const baseURL = "/v1/Pratica/Linguagem";

const service = {
  methods: {
    $buscarPraticasLinguagem(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $visualizarPraticasLinguagem({ params, id }) {
      return this.$api().get(`${baseURL}/${id}`, params);
    },
    $cadastrarPraticaLinguagem(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarPraticaLinguagem(body, id) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $inativarAtivarPraticaLinguagem(id) {
      return this.$api().patch(`${baseURL}/${id}/AlterarStatus`);
    }
  },
};

export default service;
